const apiLead = '/rest/apl-web-site-institucional/api/v2/IntegracaoVpc/IncluirLead'
// const apiLead = "https://api-h.safrafinanceira.com.br/apl-web-site-institucional/api/v2/IntegracaoVpc/IncluirLead";

let queryString = document.location.search;

function getQueryParams(key) {
  const result = new RegExp("[?&]" + key.replace(/\_/g, "_") + "=([^?&#]*)");
  const captureValue = queryString.match(result);

  if (captureValue) return captureValue[1];

  return "";
}

function getCampaignData() {
  if (!queryString) return false;
  queryString = decodeURIComponent(queryString);

  const utm = {
    source: getQueryParams("utm_source") || "",
    medium: getQueryParams("utm_medium") || "",
    campaign: getQueryParams("utm_campaign") || "",
    gclid: getQueryParams("gclid") || "",
  };

  if (
    !utm.medium &&
    !utm.gclid &&
    document.referrer &&
    !document.referrer.match(/safrafinanceira/)
  ) {
    const organicSearch = document.referrer.match(
      /(google|bing|duckduckgo|yahoo|ask)\.com/
    );
    if (organicSearch) {
      utm.source = organicSearch[1];
      utm.medium = "organic";
      utm.campaign = "";
    } else {
      utm.medium = "referral";
      utm.campaign = "";
      const refDomain = document.referrer
        .replace(/https?\:\/\//, "")
        .split("/");
      utm.source = refDomain ? refDomain[0] : "referral";
    }
  }

  return utm;
}

function generateGuid() {
  let result, value, index;
  result = "";
  for (index = 0; index < 32; index++) {
    if (index == 8 || index == 12 || index == 16 || index == 20)
      result = result + "-";
    value = Math.floor(Math.random() * 16).toString(16);
    result = result + value;
  }
  return result;
}

const getGuidSession = generateGuid();

if (!sessionStorage.getItem("idSessao")) {
  sessionStorage.setItem("idSessao", getGuidSession);
}

const formFotovoltaico = {
  form: document.querySelector(".js-form-financiamento-solar"),
  pristine: {},
  init() {
    this.formInitialize();
    this.selectOptions();
  },
  formInitialize() {
    this.pristine = new Pristine(this.form);

    IMask(this.form.querySelector("#celular"), {
      mask: "(00)00000-0000",
    });

    this.form.addEventListener("submit", (event) => {
      event.preventDefault();

      let valid = this.pristine.validate();

      if (valid) {
        this.form.querySelector("button").disabled = true;
        const leadsFormData = new FormData(this.form);
        const name = leadsFormData.get("nome");
        const phone = leadsFormData.get("celular");
        const email = leadsFormData.get("email");
        const subject =
          leadsFormData.get("assunto") === "Outros"
            ? leadsFormData.get("outros")
            : leadsFormData.get("assunto");
        const guidLead = generateGuid();
        const guidSession = sessionStorage.getItem("idSessao");
        const startDate = new Date().toISOString();
        const utm = getCampaignData();

        fetch(apiLead, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(
            // {
            //   idLead: guidLead,
            //   idSessao: guidSession,
            //   passo: 0,
            //   dsPasso: "Dados iniciais",
            //   canal: 3,
            //   dtInclusao: startDate,
            //   dtAtualizacao: startDate,
            //   campanha: {
            //     origem: utm.source,
            //     midia: utm.medium,
            //     campanha: utm.campaign
            //   },
            //   dadosPessoais: {
            //     cpfCnpj: null,
            //     nome: name,
            //     email: email,
            //     celular: phone
            //   },
            //   campoExtras: {
            //     ondeConheceuSite: subject
            //   }
            // }
            [
              {
                idLead: guidLead,
                idSessao: guidSession,
                dsTipoJornada: null,
                possuiInteressePortabilidade: false,
                isJornadaFinalizada: null,
                passo: 0,
                dsPasso: "Dados iniciais",
                observacaoAtendimento: "ondeConheceuSite: " + subject,
                campanha: {
                  origem: utm.source,
                  midia: utm.medium,
                  campanha: utm.campaign,
                },
                cliente: {
                  idCliente: null,
                  nomeCliente: name,
                  email: email,
                  cpfCnpj: null,
                  telefones: [
                    {
                      numero: phone,
                      tipoTelefone: null,
                      aparelho: null,
                      sistemaOperacional: null,
                    },
                  ],
                },
                propostas: [
                  {
                    idProposta: null,
                    dtInclusaoProposta: null,
                    dtAtualizacaoProposta: null,
                    simulacoes: [],
                    dadosPessoais: {
                      cpf: null,
                      nomeCompleto: null,
                      idUFRG: null,
                      sexo: null,
                      dataNascimento: null,
                      idEstadoCivil: null,
                      nomeMae: null,
                      rg: null,
                      email: null,
                    },
                    telefone: null,
                  },
                ],
                dtInclusao: startDate,
                dtAtualizacao: startDate,
                dtFinalizacao: null,
              },
            ]
          ),
        })
          .then((response) => {
            this.form.style.display = "none";

            if (response.ok) {
              document.querySelector(
                ".js-form-solar-message--success"
              ).style.display = "flex";
            } else {
              document.querySelector(
                ".js-form-solar-message--error"
              ).style.display = "flex";
            }

            this.form.querySelector("button").disabled = false;
          })
          .catch((err) => {
            this.form.style.display = "none";
            document.querySelector(
              ".js-form-solar-message--error"
            ).style.display = "flex";
            this.form.querySelector("button").disabled = false;
          });
      }
    });
  },
  selectOptions() {
    const select = document.querySelector("select#assunto");
    const showInput = document.querySelector(".js-toggle-visbililty");

    select.addEventListener("change", (event) => {
      if (select.value === "Outros") {
        showInput.style.display = "block";
      } else {
        showInput.style.display = "none";
      }
    });
  },
};

formFotovoltaico.init();
